import { render } from "./CheckBoxSelectPair.vue?vue&type=template&id=8add0c2a&scoped=true"
import script from "./CheckBoxSelectPair.vue?vue&type=script&lang=js"
export * from "./CheckBoxSelectPair.vue?vue&type=script&lang=js"

import "./CheckBoxSelectPair.vue?vue&type=style&index=0&id=8add0c2a&lang=less&scoped=true"

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8add0c2a"]])

export default __exports__